import type { AddCaseTemplateFormValues } from "@/components/Forms/SubForms/AddEditCaseTemplateDialog.tsx";
import DeleteIcon from "@mui/icons-material/Delete";
import { Alert, IconButton, List, ListItem, ListItemText } from "@mui/material";
import type { UseFormReturn } from "react-hook-form";

type Props = {
    form: UseFormReturn<AddCaseTemplateFormValues>;
};

const TaskTemplateTasksDisplay = ({ form }: Props) => {
    const formValue = form.watch("taskTemplates");

    const handleDelete = (id: string) => {
        if (formValue) {
            const newTasks = formValue.filter((task) => task.id !== id);
            form.setValue("taskTemplates", newTasks);
        }
    };

    return (
        <>
            {!formValue.length && <Alert severity={"warning"}>No task templates.</Alert>}
            <List>
                {formValue?.map((task) => {
                    return (
                        <ListItem
                            key={task.id}
                            secondaryAction={
                                <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() => handleDelete(task.id)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            }
                        >
                            <ListItemText primary={task.name} />
                        </ListItem>
                    );
                })}
            </List>
        </>
    );
};

export default TaskTemplateTasksDisplay;
